var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29929 10.7088L0.289286 2.64647C-0.0964286 2.25824 -0.0964286 1.62412 0.289286 1.23588L1.22786 0.291176C1.61357 -0.0970588 2.24357 -0.0970588 2.62929 0.291176L8.99357 6.68412L15.3707 0.291176C15.7564 -0.0970588 16.3864 -0.0970588 16.7721 0.291176L17.7107 1.23588C18.0964 1.62412 18.0964 2.25824 17.7107 2.64647L9.68786 10.7088C9.30214 11.0971 8.685 11.0971 8.29929 10.7088Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.003869889469de6002721907d00f4c19.svg";
export { ForwardRef as ReactComponent };